export const theme = {
  headerBgColor: "#004a8f",
  headerFontColor: "#fff",
  headerFontSize: "15px",
  botBubbleColor: "rgba(255, 191, 0, 0.55)",
  botFontColor: "#023869",
  userBubbleColor: "#fff",
  userBubbleTextAlign: "right",
  userFontColor: "#4a4a4a",
  brandingYellow: "#ffc000",
  brandingBlue: "#004a8f",
  barandingBlue6: "rgba(0, 74, 143, 0.67)",
  acceptGreen: "rgb(76, 172, 59)",
  cancelRed: "rgb(217, 100, 89)",
};
export const PAGE_LENGTH = 50;
export const SHOW_POWERBY = true;
export const API_URL = "aHR0cHM6Ly9haXRlc3QudG9zYW50ZWNobm8uY29tOjcxODU=";
export const HeaderHeight = {
  small: 80,
  larg: 90,
};
export const FooterHeight = {
  small: 56,
  larg: 56,
};
export const fonts = [
  {
    label: "کوچک",
    value: "12px",
  },
  {
    label: "متوسط",
    value: "16px",
  },
  {
    label: "بزرگ",
    value: "20px",
  },
];

export const qnaStateTypes = {
  BTC: "BTC",
  WAT: "WAT",
  LVC: "LVC",
};
export const STATE_ANSWER_INTERVAL = 1000;
